module.exports = __webpack_public_path__ + "img/icon_user.eba6f1d8.svg";